/* eslint-disable */
export default {
  start: 'Take a quick tour',
  skip: 'Skip',
  next: 'Next',
  finish: 'Finish',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
